var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-start profile-role-hld"},[(_vm.params.data.Location && _vm.params.data.Location.length > 1)?_c('div',[_vm._v("\n    Multiple\n  ")]):(_vm.params.data.Location && _vm.params.data.Location.length == 1)?_c('div',[_vm._v("\n    "+_vm._s(_vm.params.data.Location[0].Name)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }